<template>
    <div class="weChat-material">
        <div class="head">
            <div class="title"><i></i><span>素材管理列表</span></div>
        </div>
        <div class="tool-box">
            <el-tabs v-model="activeName" @tab-click="tabClick" v-if="load">
                <el-tab-pane :label="'图文素材('+countData.picText+')'" name="1"></el-tab-pane>
                <el-tab-pane :label="'图片素材('+countData.pic+')'" name="2"></el-tab-pane>
                <el-tab-pane :label="'模版消息('+countData.templateNotice+')'" name="3"></el-tab-pane>
            </el-tabs>
            <div class="tool-btn-list">
                <el-input v-model="keyword" placeholder="请输入模版消息标题" @keyup.enter.native="pageChange(1)" v-if="activeName==3"></el-input>
                <el-button type="warning" v-if="activeName==3" @click="pageChange(1)">查询</el-button>
                <el-button v-if="activeName==2" @click="delSelectPic" type="danger">批量删除图片</el-button>
                <el-button v-if="activeName==2" @click="openUploadPanel" type="warning">新增图片素材</el-button>
                <el-button v-if="activeName==3" @click="openTemplatePanel" type="warning">新增模版消息</el-button>
                <el-button type="warning" v-if="activeName!=3" @click="openDataSync">同步公众号素材</el-button>
                <el-button type="warning" v-if="activeName==3" @click="openDataSync">同步公众号模板</el-button>
            </div>
        </div>
        <div class="list-box">
            <div class="empty-box" v-if="list.length == 0&&!listLoading">
                <img src="@static/images/no.png" alt="">
                <div class="empty-text">暂无数据</div>
            </div>
            <div class="panel" v-if="activeName==1">
                <div class="list1">
                    <template v-for="(item,i) in list" >
                        <articleDetail :item="item" :key="i" v-if="i%4==0" @del="delMedia"></articleDetail>
                    </template>
                </div>
                <div class="list2">
                    <template v-for="(item,i) in list" >
                        <articleDetail :item="item" :key="i" v-if="i%4==1" @del="delMedia"></articleDetail>
                    </template>
                </div>
                <div class="list3">
                    <template v-for="(item,i) in list" >
                        <articleDetail :item="item" :key="i" v-if="i%4==2" @del="delMedia"></articleDetail>
                    </template>
                </div>
                <div class="list4">
                    <template v-for="(item,i) in list" >
                        <articleDetail :item="item" :key="i" v-if="i%4==3" @del="delMedia"></articleDetail>
                    </template>
                </div>
            </div>
            <div class="img-panel" v-if="activeName==2">
                <div class="img-item" v-for="(item,i) in list" :key="i">
                    <div class="img-box">
                        <img :src="item.url" @click="lookImg(item)">
                    </div>
                    <!-- <img src="@static/images/appcode.png" alt=""> -->
                    <div class="title">{{item.title}}</div>
                    <div class="img-info">
                        <div>
                            <el-checkbox v-model="item.checked" @change="selectPic"></el-checkbox>
                            <div class="time">更新于：{{item.updateTime|formatDate("MM月dd日")}}</div>
                        </div>
                        <div>
                            <i class="icon-bianji" @click="openEditImg(item)"></i>
                            <i class="icon-shanchu" @click="delMedia(item.id)"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel template-panel" v-if="activeName==3">
                <div class="list1">
                    <template v-for="(item,i) in list">
                        <templateDetail :item="item" :key="i" v-if="i%4==0" @reload="getList" @edit="openEditTemplate"></templateDetail>
                    </template>
                </div>
                <div class="list2">
                    <template v-for="(item,i) in list">
                        <templateDetail :item="item" :key="i" v-if="i%4==1" @reload="getList" @edit="openEditTemplate"></templateDetail>
                    </template>
                </div>
                <div class="list3">
                    <template v-for="(item,i) in list">
                        <templateDetail :item="item" :key="i" v-if="i%4==2" @reload="getList" @edit="openEditTemplate"></templateDetail>
                    </template>
                </div>
                <div class="list4">
                    <template v-for="(item,i) in list">
                        <templateDetail :item="item" :key="i" v-if="i%4==3" @reload="getList" @edit="openEditTemplate"></templateDetail>
                    </template>
                </div>
            </div>
        </div>
        <el-pagination class="page" background layout="total, prev, pager, next" @current-change="pageChange" :current-page="pageNum" :page-size='activeName==2?10:8' :total="listCount">
        </el-pagination>

        <el-dialog :title="isAddTemplate?'选择公众号':'选择需同步的公众号'" width="900px" :visible.sync="showSyncModel">
            <el-table :stripe='true' class="omtable" :data="weChatList" style="width: 100%" >
                <el-table-column label="选择" width="50" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="syncId" :label="scope.row.appid" @click.native="selectChat(scope.row)"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="公众号名称"></el-table-column>
                <el-table-column label="公众号图标">
                    <template slot-scope="scope">
                        <img :src="scope.row.headImg" v-if="scope.row.headImg" class="wechat-logo">
                    </template>
                </el-table-column>
                <el-table-column prop="serviceTypeInfo" label="公众号类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.serviceTypeInfo==1">订阅号</div>
                        <div v-if="scope.row.serviceTypeInfo==2">服务号</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page" :current-page.sync='weChatPage' background layout="total,prev, pager, next" @current-change="WeChatListPageChange" :page-size='5' :total="weChatCount">
            </el-pagination>
            <div class="btn-list">
                <el-button type="warning" plain @click="showSyncModel=false">取消</el-button>
                <el-button type="warning" @click="addTemplateNext1" v-if="isAddTemplate">下一步</el-button>
                <el-button type="warning" @click="getWeChatData" v-else>确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="上传图片素材" width="900px" :visible.sync="showUploadModel" @close="getList()">
            <el-form :model="uploadForm" label-width="90px" ref='form' label-position="right">
                <el-form-item label="公众号" prop="appid" :rules="[rules.required('请选择公众号')]">
                    <el-select v-model="uploadForm.appid" placeholder="请选择公众号再上传">
                        <el-option
                            v-for="item in weChatList"
                            :key="item.appid"
                            :label="item.name"
                            :value="item.appid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上传图片"  v-if="uploadForm.appid">
                    <el-upload
                        ref="upload"
                        :data="uploadForm"
                        :action="api_root+'/wechatthirdplat/subscriptionMedia/uploadImageMedia'"
                        multiple
                        :file-list="uploadImg"
                        list-type="picture-card"
                        :on-change="selectUploadImg"
                        :on-remove="selectUploadImg"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :auto-upload="false"
                        :limit="10">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div class="btn-list">
                <el-button type="warning" plain @click="showUploadModel=false">取消</el-button>
                <el-button type="warning" @click="uploadSubmit">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑图片" width="600px" :visible.sync="editImgModel">
            <el-form :model="editForm" label-width="90px" ref='form' label-position="right">
                <el-form-item label="图片名称" prop="title" :rules="[rules.required('请输入图片名称')]">
                    <el-input placeholder="请输入图片名称" v-model="editForm.title"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-list">
                <el-button type="warning" plain @click="editImgModel=false">取消</el-button>
                <el-button type="warning" @click="editImgSubmit">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="新增模板消息素材" width="900px" :visible.sync="showTemplatePanel1">
            <el-table :stripe='true' :data="templateList" style="width: 100%">
                <el-table-column label="选择" width="50" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="templateId" :label="scope.row.templateId" @click.native="selectTemplate(scope.row)"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="templateId" label="模板ID" width="400"></el-table-column>
                <el-table-column prop="title" label="标题" width="180"></el-table-column>
                <el-table-column prop="primaryIndustry" label="一级行业"></el-table-column>
                <el-table-column prop="deputyIndustry" label="二级行业"></el-table-column>
            </el-table>
            <el-pagination class="page" :current-page.sync='templatePage' background layout="total,prev, pager, next" @current-change="templatePageChange" :page-size='8' :total="templateCount">
            </el-pagination>
            <div class="btn-list">
                <el-button type="warning" plain @click="showTemplatePanel1=false">返回</el-button>
                <el-button type="warning" @click="addTemplateNext2">下一步</el-button>
            </div>
        </el-dialog>

        <el-dialog class="template-form" :title="templateForm.id?'编辑模板消息素材':'新增模板消息素材'" :close-on-click-modal="false"
            width="600px" :visible.sync="showTemplatePanel2">
            <el-form :model="templateForm" label-width="120px" ref='form' label-position="right">
                <el-form-item label="模版ID" style="margin-bottom: 0;">
                    <div>{{templateData.templateId}}</div>
                </el-form-item>
                <el-form-item label="模版标题" style="margin-bottom: 10px;">
                    <div>{{templateData.title}}</div>
                </el-form-item>
                <el-form-item label="详细内容" prop="first" :rules="[rules.required('请输入详细内容')]">
                    <el-input placeholder="请输入详细内容" v-model="templateForm.first" maxlength="200"></el-input>
                    <el-color-picker v-model="templateForm.color.firstColor"></el-color-picker>
                </el-form-item>
                <el-form-item :label="templateData.keyword1" v-if="templateData.keyword1!=0" prop="keyword1"
                        :rules="[rules.required('请输入'+templateData.keyword1)]">
                    <el-input :placeholder="'请输入'+templateData.keyword1" v-model="templateForm.keyword1" maxlength="200"></el-input>
                    <el-color-picker v-model="templateForm.color.keyword1Color"></el-color-picker>
                </el-form-item>
                <el-form-item :label="templateData.keyword2" v-if="templateData.keyword2!=0" prop="keyword2"
                        :rules="[rules.required('请输入'+templateData.keyword2)]">
                    <el-input :placeholder="'请输入'+templateData.keyword2" v-model="templateForm.keyword2" maxlength="200"></el-input>
                    <el-color-picker v-model="templateForm.color.keyword2Color"></el-color-picker>
                </el-form-item>
                <el-form-item :label="templateData.keyword3" v-if="templateData.keyword3!=0" prop="keyword3"
                        :rules="[rules.required('请输入'+templateData.keyword3)]">
                    <el-input :placeholder="'请输入'+templateData.keyword3" v-model="templateForm.keyword3" maxlength="200"></el-input>
                    <el-color-picker v-model="templateForm.color.keyword3Color"></el-color-picker>
                </el-form-item>
                <el-form-item :label="templateData.keyword4" v-if="templateData.keyword4!=0" prop="keyword4"
                        :rules="[rules.required('请输入'+templateData.keyword4)]">
                    <el-input :placeholder="'请输入'+templateData.keyword4" v-model="templateForm.keyword4" maxlength="200"></el-input>
                    <el-color-picker v-model="templateForm.color.keyword4Color"></el-color-picker>
                </el-form-item>
                <el-form-item :label="templateData.keyword5" v-if="templateData.keyword5!=0" prop="keyword5"
                        :rules="[rules.required('请输入'+templateData.keyword5)]">
                    <el-input :placeholder="'请输入'+templateData.keyword5" v-model="templateForm.keyword5" maxlength="200"></el-input>
                    <el-color-picker v-model="templateForm.color.keyword5Color"></el-color-picker>
                </el-form-item>
                <el-form-item label="消息备注" prop="remark" :rules="[rules.required('请输入消息备注')]">
                    <el-input placeholder="请输入消息备注" v-model="templateForm.remark" maxlength="200"></el-input>
                    <el-color-picker v-model="templateForm.color.remarkColor"></el-color-picker>
                </el-form-item>
                <el-form-item label="链接地址" prop="url" :rules="[rules.url()]">
                    <el-input placeholder="请输入链接地址" v-model="templateForm.url" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item label="内容示例">
                    <div class="demo-text" :style="{color:templateForm.color.firstColor}">{{templateForm.first}}</div>
                    <div class="demo-text" v-if="templateForm.keyword1">
                        {{templateData.keyword1}}: <span :style="{color:templateForm.color.keyword1Color}">{{templateForm.keyword1}}</span>
                    </div>
                    <div class="demo-text" v-if="templateForm.keyword2">
                        {{templateData.keyword2}}: <span :style="{color:templateForm.color.keyword2Color}">{{templateForm.keyword2}}</span>
                    </div>
                    <div class="demo-text" v-if="templateForm.keyword3">
                        {{templateData.keyword3}}: <span :style="{color:templateForm.color.keyword3Color}">{{templateForm.keyword3}}</span>
                    </div>
                    <div class="demo-text" v-if="templateForm.keyword4">
                        {{templateData.keyword4}}: <span :style="{color:templateForm.color.keyword4Color}">{{templateForm.keyword4}}</span>
                    </div>
                    <div class="demo-text" v-if="templateForm.keyword5">
                        {{templateData.keyword5}}: <span :style="{color:templateForm.color.keyword5Color}">{{templateForm.keyword5}}</span>
                    </div>
                    <div class="demo-text" :style="{color:templateForm.color.remarkColor}">{{templateForm.remark}}</div>
                </el-form-item>
            </el-form>
            <div class="btn-list">
                <el-button type="warning" plain @click="showTemplatePanel2=false">{{templateForm.id?'取消':'返回'}}</el-button>
                <el-button type="warning" @click="templateSubmit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import articleDetail from "./components/articleDetail";
import templateDetail from "./components/templateDetail";
import {ruleTool} from '@/api/mixins'
import common from '@/api/common'
import config from './material.config'
//当前实例组件
export default {
    mixins: [ruleTool],
    data: () => (config),
    components: {articleDetail,templateDetail},
    mounted() {
        this.activeName = "1";
        this.api_root = this.$config.api_root;
        this.uploadForm.userId = this.$tools.getLocal("userinfo").id
        this.userId = this.$tools.getLocal("userinfo").id
        this.getList();
    },
    methods: {
        lookImg(item){
            window.open(item.url);
        },
        openEditTemplate(item) {
            this.templateData = {
                templateId:item.templateId,
                title:item.title,
                keyword1:item.keyword1Const,
                keyword2:item.keyword2Const,
                keyword3:item.keyword3Const,
                keyword4:item.keyword4Const,
                keyword5:item.keyword5Const,
            }
            this.templateForm = item;
            this.showTemplatePanel2 = true;
        },
        // 保存模板消息
        templateSubmit(){
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请输入正确的信息');
                    return;
                }
                const params = Object.assign({},this.templateForm);
                params.color = JSON.stringify(params.color);
                params.title = this.templateData.title;
                params.templateId = this.templateData.templateId;
                if(!params.id){
                    params.subscriptionId = this.selectChatArr.join('');
                }
                if(this.sending){
                    return;
                }
                this.sending = true;
                this.$http({
                    url:'/wechatthirdplat/standardTemplate',
                    type:'post',
                    params: params,
                }).then((data)=> {
                    this.sending = false;
                    this.showSyncModel = false;
                    this.showTemplatePanel1 = false;
                    this.showTemplatePanel2 = false;
                    this.getList();
                    this.$message.success(this.templateForm.id?'编辑模板消息成功':'新增模板消息成功');
                }).catch((err)=>{
                    this.sending = false;
                });
            });
        },
        addTemplateNext1(){
            if(this.selectChatArr.length==0) {
                this.$message.error('请选择一个公众号');
                return;
            }
            this.templatePageChange(1);
        },
        addTemplateNext2(){
            if(this.templateId=="") {
                this.$message.error('请选择一个模板');
                return;
            }
            this.showTemplatePanel2 = true;
            this.templateForm = {
                color:{
                    "firstColor":"#000",
                    "remarkColor":"#000",
                    "keyword1Color":"#000",
                    "keyword2Color":"#000",
                    "keyword3Color":"#000",
                    "keyword4Color":"#000",
                    "keyword5Color":"#000"
                }
            };
            // this.$http({
            //     name: 'templateDetail',
            //     params: this.templateForm,
            // }).then((data)=> {
            //     this.showTemplatePanel1 = false;
            //     this.showTemplatePanel2 = true;
            // })
        },
        // 选择模板
        selectTemplate(row){
            this.templateData = row;
        },
        // 新增模板消息弹窗
        openTemplatePanel(){
            this.weChatPage = 1;
            this.isAddTemplate = true;
            this.getWeChatList();
        },
        // 新增模板消息 模板列表翻页
        templatePageChange(page){
            this.templateId = "";
            this.templatePage = page;
            const params = {
                pageSize: 8,
                pageNum: this.templatePage,
                subscriptionId:this.selectChatArr.join('')
            }
            this.$http({
                url:'/wechatthirdplat/subscriptiontemplate/read/list',
                type:'put',
                params: params,
            }).then((data)=> {
                this.templateList = data.data;
                this.templateCount = data.total;
                this.showTemplatePanel1 = true;
            })
        },
        // 打开编辑图片弹窗
        openEditImg(item) {
            this.editImgModel = true;
            this.editForm = {
                id:item.id,
                title:item.title
            };
        },
        // 提交编辑的图片信息
        editImgSubmit(){
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请输入正确的信息');
                    return;
                }
                this.$http({
                    url:'/wechatthirdplat/subscriptionMedia',
                    type:'post',
                    params: this.editForm,
                }).then((data)=> {
                    this.editImgModel = false;
                    this.getList();
                    this.$message.success('编辑图片成功');
                });
            });
        },
        uploadError(){
            this.$message.success('图片上传失败');
        },
        uploadSuccess(e){
            if(e.httpCode==200){
                this.$refs.upload.clearFiles();
                this.showUploadModel = false;
                this.$message.success('图片上传成功');
            }else{
                this.$message.error(e.msg);
            }
        },
        // 选择需要上传的图片
        selectUploadImg(file, fileList){
            this.uploadImg = fileList;
        },
        // 上传图片提交
        uploadSubmit(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if(this.uploadImg.length) {
                        this.$refs.upload.submit();
                    } else {
                        this.$message.error('请选择需要上传的图片');
                    }
                } else {
                    this.$message.error('请选择公众号');
                }
            });
        },
        // 打开上传图片弹窗
        openUploadPanel(){
            this.weChatPage=1;
            this.uploadForm={userId:this.userId};
            this.getWeChatList(true);
        },
        // uploadFile(e){
        //     var fd = new FormData();
        //     fd.append('file', e.file);
        //     fd.append('userId', this.uploadForm.userId);
        //     fd.append('appid', this.uploadForm.appid);
        //     this.$http({
        //         name: 'uploadImageMedia',
        //         params: fd,
        //     }).then(function(data) {
        //         console.log(data);
        //     });
        // },
        //选择图片
        selectPic(){
            this.selectPicArr = [];
            this.list.forEach(item =>{
                if(item.checked){
                    this.selectPicArr.push(item.id);
                }
            });
        },
        // 删除选择的图片
        delSelectPic(){
            if(this.selectPicArr.length) {
                this.delMedia(this.selectPicArr)
            }else{
                this.$message.info('请选择需要删除的图片');
            }
        },
        // 获取tab统计数量
        getCount(){
            this.$http({
                url:'/wechatthirdplat/subscriptionMedia/queryTotal',
                type:'put',
                params:{
                    userId:this.userId
                }
            }).then((data)=> {
                this.countData = data.data;
                this.load = true;
            })
        },
        // 删除素材
        delMedia(id) {
            this.$confirm(
                '确认删除素材？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            .then(()=> {
                this.$http({
                    url:'/wechatthirdplat/subscriptionMedia',
                    type:'delete',
                    params: {ids:id},
                }).then((data)=> {
                    this.selectPicArr = []
                    this.getList();
                    this.$message.success('删除成功');
                });
            })
        },
        // 选择公众号
        selectChat(item){
            if(this.isAddTemplate){
                this.selectChatArr = [item.id];
            }else{
                this.selectChatArr = [item.appid];
            }
        },
        // 打开公众号授权弹窗
        openDataSync(){
            this.weChatPage = 1;
            this.isAddTemplate = false;
            this.getWeChatList();
        },
        // 同步公众号数据
        getWeChatData(){
            let ajaxUrl = "/wechatthirdplat/subscriptionMedia/manualSyncMedia";
            if(this.activeName == 3){
                ajaxUrl = "/wechatthirdplat/subscriptiontemplate/manualSyncTemplate";
            }
            const loading = this.$notice.loading();
            this.$http({
                url: ajaxUrl,
                type:'put',
                params:{
                    appid:this.selectChatArr.join(",")
                }
            }).then((data)=> {
                loading.close();
                this.showSyncModel = false;
                this.pageChange(1);
                this.$message.success('同步成功');
            })
        },
        // 公众号列表翻页
        WeChatListPageChange(page){
            this.weChatPage = page;
            this.getWeChatList();
        },
        // 获取公众号列表
        getWeChatList(isList){
            const params = {
                pageSize:8,
                pageNum:this.weChatPage,
                userId:this.userId
                // userId:"1260394473490165760"
            }
            if(this.activeName == 2){
                params.pageSize = 100;
            }
            this.selectChatArr = [];
            this.syncId="";
            this.$http({
                url:'/wechatthirdplat/kefuSubscriptionQuantity/queryQuantitySubscription',
                type:'put',
                params: params,
            }).then((data)=> {
                if(data.total==0){
                    this.$message.info('暂无公众号数据');
                }else {
                    if(isList) {
                        this.weChatList = data.data;
                        this.showUploadModel = true;
                        return;
                    }
                    if(this.isAddTemplate){
                        this.showSyncModel = true;
                        this.weChatList = data.data;
                        this.weChatCount = data.total;
                        return;
                    }
                    if(data.total==1){
                        if(this.isAddTemplate){
                            this.selectChatArr = [data.data[0].id];
                            this.templatePageChange(1);
                        }else{
                            this.selectChatArr = [data.data[0].appid];
                            this.getWeChatData();
                        }

                    }else{
                        this.showSyncModel = true;
                        this.weChatList = data.data;
                        this.weChatCount = data.total;
                    }
                }
            })
        },
        // tab点击
        tabClick(){
            this.pageNum = 1;
            this.getList();
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        // 获取列表数据
        getList(){
            this.getCount();
            let ajaxUrl = "/wechatthirdplat/subscriptionMedia/read/list";
            let ajaxType = "post";
            const params = {
                userId: this.userId,
                pageSize: 8,
                type: this.activeName,
                pageNum: this.pageNum
            }
            if(this.activeName == 3) {
                ajaxUrl = "/wechatthirdplat/standardTemplate/read/customList";
                params.title = this.keyword;
                ajaxType = "put";
            }
            if(this.activeName == 2) {
                params.pageSize = 10;
            }
            this.listLoading = true;
            this.list=[];
            this.$http({
                url: ajaxUrl,
                type: ajaxType,
                params: params,
            }).then((data)=> {
                this.listLoading = false;
                if(this.activeName==1){
                    data.data.forEach(item=>{
                        if(item.articles){
                            item.articles = JSON.parse(item.articles);
                        }
                        item.digest = item.articles[0].digest;
                        item.thumb_url = item.articles[0].thumb_url;
                        item.url = item.articles[0].url;
                    });
                }else if(this.activeName==2){
                    data.data.forEach(item=>{
                        item.checked = false;
                    });
                }else if(this.activeName==3){
                    data.data.forEach(item=>{
                        if(item.color){
                            item.color = JSON.parse(item.color)
                        }else{
                            item.color = {};
                        }
                    });
                }
                this.list = data.data;
                this.listCount = data.total;
            })
        }
    },

};
</script>
<style lang="scss">
@import "./material";
</style>
